module.exports = __webpack_public_path__ + "static/media/Microsoft_Azure.ace36ca4.png";